import { Box, Typography, Sheet } from "@mui/joy";
export default function Tak(){
    return(<Box><Sheet variant="soft" sx={{p:2, m:2}}><Typography level="h2">Tak for din booking</Typography>
    <Typography>Vi glæder os til at tage imod jer :)</Typography>
    <Typography>Du vil modtage en bekræftelse på mail fra booking@uc-booking.dk</Typography>
    <Typography>husk at tjekke spamfilteret og tilføj eventuelt addressen til dine kontakter</Typography></Sheet></Box>);
}